// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Webapi__Dom__Element from "../../../../node_modules/rescript-webapi/lib/es6_global/src/Webapi/Dom/Webapi__Dom__Element.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function useNavbarEmptyAlert(navbarCategories) {
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var topLevelCategories = match.categories;
  var configId = match.id;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var embedType = match$1.embedType;
  var router = RouterProvider$Showside.useRouter(undefined);
  var isPreview = RouterProvider$Showside.isPreview(router);
  var isNavBeingHiddenWithDisplayNone = Belt_Array.some(Belt_Array.map(Belt_Array.map(Array.prototype.slice.call(document.querySelectorAll("#maker-smartnav, #maker-smartnav-inline, #maker-smartnav-launcher, #maker-smartnav-section, #maker-smartnav-pdp")), Webapi__Dom__Element.ofNode), function (node) {
    return Belt_Option.map(node, function (node) {
      return window.getComputedStyle(node).display;
    });
  }), function (display) {
    return Caml_obj.equal(display, "none");
  });
  React.useEffect(function () {
    if (!isNavBeingHiddenWithDisplayNone && !isPreview && embedType !== /* Inline */1 && navbarCategories.length === 0) {
      var url = window.location.href;
      var categoriesWithLinkThatMatchesUrl = Category$Showside.findCategoriesBy(topLevelCategories, function (cat) {
        return Caml_obj.equal(Category$Showside.getCategoryLink(cat), url);
      });
      RollbarInstance$Showside.warning2("Sitewide Nav is rendering an empty navbar", {
        url: url,
        configId: configId,
        feature: "pagenav",
        extraInfo: settings.contextualL1s ? "Page nav is active and these are the categories that have a link that matches the URL:\n" + categoriesWithLinkThatMatchesUrl.map(function (category) {
          var path = Category$Showside.getCategoryPathById(topLevelCategories, category.id).map(function (cat) {
            return cat.title;
          });
          var pathStr = path.join(" -> ");
          return "\"" + category.title + "\"" + (path.length > 1 ? " (" + pathStr + ")" : "") + "";
        }).join(",\n ") + "\n          " : ""
      });
    }
  }, [isNavBeingHiddenWithDisplayNone, isPreview, embedType, topLevelCategories.length, navbarCategories.length]);
}
export { useNavbarEmptyAlert };
/* react Not a pure module */